/** The ARIA wiring a vendor control needs from its field: the description ids and the verdict. */
export const fieldControlAria = (control: {
  readonly describedby: string | undefined
  readonly invalid: boolean
}): { 'aria-describedby': string | undefined; 'aria-invalid': boolean } => ({
  'aria-describedby': control.describedby,
  'aria-invalid': control.invalid
})
